module.exports = __webpack_public_path__ + "img/sl.b40874c7.svg";